import { Routes } from '@angular/router';
import { LoggedInGuard } from '../shared/logged-in.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then( m => m.HomePage),
    canActivate: [LoggedInGuard],

  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/account/profile/profile.page').then( m => m.ProfilePage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'change-password/:idUser',
    loadComponent: () => import('./pages/account/change-password/change-password.page').then( m => m.ChangePasswordPage),
    canActivate: [],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/account/login/login.page').then( m => m.LoginPage),
    canActivate: [],
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/account/forgot-password/forgot-password.page').then( m => m.ForgotPasswordPage),
    canActivate: [],
  },
  {
    path: 'add-packaging',
    loadComponent: () => import('./pages/add-packaging/add-packaging.page').then( m => m.AddPackagingPage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'weigh-packaging',
    loadComponent: () => import('./pages/weigh-packaging/weigh-packaging.page').then( m => m.WeighPackagingPage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'collect-packaging',
    loadComponent: () => import('./pages/collect-packaging/collect-packaging.page').then( m => m.CollectPackagingPage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'deliver-packaging',
    loadComponent: () => import('./pages/deliver-packaging/deliver-packaging.page').then( m => m.DeliverPackagingPage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'agrupated-weigh-packaging',
    loadComponent: () => import('./pages/agrupated-weigh-packaging/agrupated-weigh-packaging.page').then(m => m.AgrupatedWeighPackagingPage),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'packaging-queries',
    loadComponent: () => import('./pages/packaging-queries/packaging-queries.page').then( m => m.PackagingQueriesPage)
  },
  {
    path: 'bluetooth',
    loadComponent: () => import('../components/bluetooth-reader/bluetooth-reader.component').then( m => m.BluetoothReaderComponent),
    canActivate: [LoggedInGuard],
  },

];
